import { Route, Routes } from 'react-router-dom';

import PostRequestOverrideDetailView from './PostRequestOverrideDetailView';
import PostRequestOverrideList from './PostRequestOverrideList';

function PostRequestOverride() {
  return (
    <Routes>
      <Route index path="" element={<PostRequestOverrideList />} />
      <Route path=":id" element={<PostRequestOverrideDetailView />} />
    </Routes>
  );
}

export default PostRequestOverride;
